import { BlueprintStepTemplate } from "../../../models/Blueprints";
import JSONSchemaTreeDiagram from "../../shared/JSONSchemaTreeDiagram";
import { Text } from "@merge-api/merge-javascript-shared";

interface Props {
  stepID: string;
  stepTemplate: BlueprintStepTemplate;
}

const BlueprintEditorRightPanelGetLinkedAccountFields = ({ stepID, stepTemplate }: Props) => {
  return (
    <>
      <Text variant="pre-title" className="my-3 text-gray-40">
        Available fields
      </Text>
      <JSONSchemaTreeDiagram stepID={stepID} jsonSchema={stepTemplate.return_schema} />
    </>
  );
};

export default BlueprintEditorRightPanelGetLinkedAccountFields;
